<template>
  <section>
    <div class="row mb-3 d-flex">
      <div class="col-md-8">
        <h5 class="text-left">{{ $t("lang.onBoarding.total_contacts_matching_criteria") }}</h5>
      </div>
      <div class="col-md-4">

          <p class="border border-primary py-1 px-1 rounded-pill text-primary text-center font-weight-bold"> 
               <span 
                v-if="isDisable"
                  class="loadingres mr-2 ml-2 spinner-border loading-spinner" 
                ></span>
            <span v-if="!isDisable">{{ $t("lang.onBoarding.prospects",{'prospects':new Intl.NumberFormat('es-ES').format(apollo.total_result) }) }}</span> </p>
           
      </div>
    </div>
    
    <div class="col-md-12 ">
      <div>
            <ContactPreview  :key="contactkey" :contacts="apollo.people" 
            v-if="apollo.total_result > 0  && !isDisable" />
            <LoadingSpinner  v-if="isDisable"/>
            <span v-if="apollo.total_result == 0 && !isDisable"> No contacts</span>
      </div>
    </div>
    
  </section>
</template>

<script>
import ContactPreview from '@/components/Contacts/ContactPreview.vue';
import { mapState, mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";


export default {
  computed: {
    ...mapState({
      apollo: (state) => state.onboarding.apollo,
      isDisable: (state) => state.onboarding.isDisable,
    }), 
  },
  created(){
    if(this.simplify){
      this.apolloData(this.contacts)
    }
  },

  methods: {
    ...mapActions("onboarding", {
      apolloData : "apolloData",
    }),
  },
  props: {
    contacts: {},
    contactkey:Number,
    simplify:{
      default:false,
      type:Boolean
    }
  },
  components: { ContactPreview,LoadingSpinner },
  }
</script>